import { IBillsSliceInitialStateInterface } from './billsSlice.types'

const billsSliceInitialState: IBillsSliceInitialStateInterface = {
  selected: {
    event: null,
    eventFees: null,
    recipient: null,
    recipientsTotals: [],
  },
}

export { billsSliceInitialState }
